<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 subtitle-1">
          <v-icon small>mdi-content-save-plus-outline</v-icon>Add Beneficiary
        </div>
        <div>
          <bread-crumb
            :bread-crumbs="[
              'List of Customers',
              'List-Overview',
              'Benficiary Tabs',
            ]"
          />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>

      <v-tabs
        background-color=""
        right
        dense
        next-icon="mdi-arrow-right-bold-box"
        prev-icon="mdi-arrow-left-bold-box"
        show-arrows
        v-model="currentItem"
        slider-color="primary"
      >
        <v-tab
          class="text-decoration-none text-capitalize"
          href="#Ind_Beneficiary"
        >
          Individual
        </v-tab>
        <v-tab
          class="text-decoration-none text-capitalize"
          href="#Bus_Beneficiary"
        >
          Bussiness
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="currentItem" class="mt-5">
        <v-tab-item value="Ind_Beneficiary">
          <v-card flat>
            <addIndBeneficiary />
          </v-card>
        </v-tab-item>
        <v-tab-item value="Bus_Beneficiary">
          <v-card flat>
            <addBussBeneficiary />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </section>
</template>

<script>
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import addBussBeneficiary from "./addBussBeneficiary.vue";
import addIndBeneficiary from "./addIndBeneficiary.vue";

export default {
  name: "Benficiary Tabs",
  data() {
    return {
      currentItem: "",
    };
  },
  components: {
    addBussBeneficiary,
    addIndBeneficiary,
    BreadCrumb,
  },
};
</script>

<style></style>
